export const MENUITEMS = [
  {
    menutitle: "Inicio",
    menucontent: "",
    Items: [
      {
        path: `/dashboard`,
        icon: "home",
        type: "link",
        active: false,
        title: "Dashboard",
        roles: ["ADMIN", "ADMIN_ASSISTANT"]
      }
    ],
  },
  {
    menutitle: "Tienda",
    menucontent: "",
    Items: [
      {
        path: `/category`,
        icon: "ui-kits",
        type: "link",
        active: false,
        title: "Categorias",
        roles: ["ADMIN", "ADMIN_ASSISTANT", "ASSISTANT"]
      },
      {
        path: `/product`,
        icon: "ecommerce",
        type: "link",
        active: false,
        title: "Productos",
        roles: ["ADMIN", "ADMIN_ASSISTANT", "ASSISTANT"]
      },
      {
        path: `/order`,
        icon: "to-do",
        type: "link",
        active: false,
        title: "Ordenes",
        roles: ["ADMIN", "ADMIN_ASSISTANT", "ASSISTANT"]
      }
    ],
  },
  {
    menutitle: "Usuarios",
    menucontent: "",
    Items: [
      {
        path: `/user`,
        icon: "user",
        type: "link",
        active: false,
        title: "Clientes",
        roles: ["ADMIN", "ADMIN_ASSISTANT", "ASSISTANT"]
      },
      {
        path: `/administrator`,
        icon: "contact",
        type: "link",
        active: false,
        title: "Administradores",
        roles: ["ADMIN"]
      }
    ],
  },
  {
    menutitle: "Red",
    menucontent: "",
    Items: [
      {
        path: `/influencer-bonus`,
        icon: "bonus-kit",
        type: "link",
        active: false,
        title: "Bono de Influencer",
        roles: ["ADMIN", "ADMIN_ASSISTANT", "ASSISTANT"]
      },
      {
        path: `/loyalty`,
        icon: "charts",
        type: "link",
        active: false,
        title: "Regalias",
        roles: ["ADMIN", "ADMIN_ASSISTANT", "ASSISTANT"]
      },
      {
        path: `/rank`,
        icon: "board",
        type: "link",
        active: false,
        title: "Rangos",
        roles: ["ADMIN", "ADMIN_ASSISTANT", "ASSISTANT"]
      },
      // { 
      //   path: `/withdrawal`, 
      //   icon: "faq", 
      //   type: "link", 
      //   active: false, 
      //   title: "Retiros",
      //   roles: ["ADMIN","ADMIN_ASSISTANT"] 
      // }
    ],
  },
  {
    menutitle: "Alertas e inteligencia",
    menucontent: "",
    Items: [
      {
        path: `/critical-alerts`,
        icon: "faq",
        type: "link",
        active: false,
        title: "Alertas e inteligencia",
        roles: ["ADMIN", "ADMIN_ASSISTANT"]
      }
    ],
  },
  {
    menutitle: "Configuraciónes",
    menucontent: "",
    Items: [
      {
        path: `/banner`,
        icon: "gallery",
        type: "link",
        active: false,
        title: "Banner",
        roles: ["ADMIN", "ADMIN_ASSISTANT"]
      },
      {
        path: `/countries-available`,
        icon: "maps",
        type: "link",
        active: false,
        title: "Paises",
        roles: ["ADMIN"]
      },
      {
        path: `/logistics`,
        icon: "job-search",
        type: "link",
        active: false,
        title: "Logistica",
        roles: ["ADMIN", "ASSISTANT"]
      }
    ],
  },
  
];